<template>
  <div class="app-container">
    <el-form class="header-filter">
      <div class="filter-container">
        <div class="filter-form">
          <el-form-item>
            <el-input v-model="query.content" @keyup.enter.native="resetList" placeholder="名称" />
          </el-form-item>
          <el-form-item>
            <el-select v-model="query.type" @change="resetList">
              <el-option label="DOMAIN" value="DOMAIN"></el-option>
              <el-option label="TASK" value="TASK"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select v-model="locale" @change="resetList">
              <el-option v-for="e in i18nConfig.locales" :key="e" :label="e" :value="e"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select v-model="query.status" @change="resetList" clearable placeholder="上下架">
              <el-option label="上架" value="AVAILABLE"></el-option>
              <el-option label="下架" value="UNAVAILABLE"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="filter-btns">
          <el-button @click="resetList" type="primary">查询</el-button>
          <el-button @click="openDialog">新增</el-button>
        </div>
      </div>
    </el-form>

    <div class="table-wrapper">
      <el-table ref="table" :data="list" v-loading="listLoading">
        <el-table-column align="left" type="index" width="60" label="#"></el-table-column>
        <el-table-column align="center" label="名称" prop="content" min-width="180" />
        <el-table-column align="center" label="slugName" prop="slugName" min-width="180" />
        <el-table-column align="center" label="createTime" width="200">
          <template slot-scope="scope">
            {{ +scope.row.createTime | filterTimeStamp }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="updateTime" width="200">
          <template slot-scope="scope">
            {{ +scope.row.updateTime | filterTimeStamp }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="上下架" width="100" fixed="right">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              @change="handleUpdate(scope.row)"
              active-value="AVAILABLE"
              inactive-value="UNAVAILABLE"
            />
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="200" fixed="right">
          <template slot-scope="scope">
            <el-button @click="openDialog(scope.row)" type="primary" size="mini"> 编辑 </el-button>
            <el-button @click="handleDelete(scope.row)" size="mini" type="danger"> 删除 </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="query.current"
          :total="listTotal"
          :page-sizes="[10, 20, 30, 50]"
        />
      </div>
    </div>

    <el-dialog :title="currentRow.id ? '编辑' : '新增'" :visible.sync="dialogVisible" width="500px">
      <el-form class="post-main-container post-dialog-container" label-position="right">
        <el-form-item label="名称：" required>
          <el-input v-model.trim="currentRow.content" />
        </el-form-item>
        <el-form-item label="slugName：">
          <el-input v-model.trim="currentRow.slugName" :disabled="checkEditAble()" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关闭</el-button>
        <el-button type="primary" :loading="btnLoading" @click="postEdit">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getCategories, updateCategory, deleteCategory } from '@/api/categories'
import { i18nConfig } from '@/utils'

const defaultRow = {
  content: '',
  slugName: '',
  status: 'UNAVAILABLE'
}

export default {
  data() {
    return {
      i18nConfig,
      list: [],
      listTotal: null,
      listLoading: true,

      query: {
        content: '',
        limit: 10,
        current: 1,
        type: 'DOMAIN'
      },

      locale: i18nConfig.defaultLocale,

      btnLoading: false,
      dialogVisible: false,
      currentRow: {}
    }
  },

  mounted() {
    this.resetList()
  },

  methods: {
    checkEditAble() {
      const { slugName } = this.currentRow
      return slugName === 'all-domains' || slugName === 'all-tasks'
    },

    openDialog(row) {
      const copyData = row.id ? row : defaultRow
      this.currentRow = JSON.parse(JSON.stringify(copyData))
      this.dialogVisible = true
    },

    postEdit() {
      if (!this.currentRow.content) return
      const form = JSON.parse(JSON.stringify(this.currentRow))
      form.type = form.type || this.query.type
      this.btnLoading = true
      this.handleUpdate(form)
        .then(() => {
          this.dialogVisible = false
        })
        .finally(() => {
          this.btnLoading = false
        })
    },

    handleDelete(row) {
      const { id, content } = row
      this.$confirm(`是否删除分类 ${content}`, '提示', {}).then(() => {
        deleteCategory(id, this.locale).then(() => {
          this.getList()
        })
      })
    },

    handleUpdate(row) {
      return new Promise((resolve, reject) => {
        updateCategory(row, this.locale)
          .then(() => {
            this.getList()
            resolve()
          })
          .catch(() => {
            reject()
          })
      })
    },

    resetList() {
      this.query.current = 1
      this.getList()
    },

    getList() {
      this.listLoading = true
      getCategories(this.query, this.locale).then((res) => {
        this.list = res.result.rows
        this.listTotal = +res.result.total
        this.listLoading = false
      })
    },

    handleSizeChange(val) {
      this.query.limit = val
      this.resetList()
    },

    handleCurrentChange(val) {
      this.query.current = val
      this.getList()
    }
  }
}
</script>
